<template>
    <v-menu
        top
        right
        v-model="formPopup"
        :close-on-click="true"
        :close-on-content-click="false"
        offset-y
        nudge-top="20px"
        transition="slide-x-reverse-transition"
    >
        <template v-slot:activator="{ on }">
            <v-badge
                color="green"
                :content="selectedItems.length"
                overlap
                offset-x="20"
                offset-y="15"
                :value="!!selectedItems.length"
                style="position: fixed; right: 12px; bottom: 20px; z-index: 5;"
            >
                <v-btn
                    color="blue"
                    large
                    fab
                    v-on="on"
                >
                    <v-icon icon v-if="!formPopup" color="white">mdi-account-switch</v-icon>
                    <v-icon icon v-else color="white">mdi-close</v-icon>
                </v-btn>
            </v-badge>
        </template>
        <v-card min-width="300px" class="pa-5" :disabled="selectedItems.length === 0">
            <v-form ref="moveForm">
                <div class="mb-2">Selected <selected-items-info text="items" :items="selectedItems" :unSelectItem="unSelectItem" :clearSelectedList="clearSelectedList"></selected-items-info></div>
                <div class="error--text mb-2" v-if="errorMessage.length > 0">
                    {{errorMessage}}
                </div>
                <v-radio-group v-model="status">
                    <v-radio :value="ROTA_STATUSES.working">
                        <template v-slot:label>
                            <div class="d-block">Working in Unit <div class="body-2">(keep empty if no change needed)</div></div>
                        </template>
                    </v-radio>
                    <v-card :disabled="status !== ROTA_STATUSES.working" class="mb-2" style="background: none;border: none;border-radius: 0;box-shadow: none;">
                        <v-autocomplete
                            :items="getClinics"
                            item-text="title"
                            item-value="id"
                            v-model="formClinicId"
                            placeholder="Clinic"
                            solo
                            dense
                            lighten-1
                            @change="clinicChangeHandler"
                            class="mb-3"
                        ></v-autocomplete>
                        <div class="mb-3">As a</div>
                        <v-autocomplete
                            :items="$store.getters.getRoles"
                            item-text="title"
                            item-value="id"
                            v-model="formRoleId"
                            placeholder="Roles"
                            solo
                            dense
                            lighten-1
                            class="mb-3"
                        ></v-autocomplete>
                        <v-autocomplete
                            :items="clinicSurgeries"
                            clearable
                            item-text="value"
                            item-value="id"
                            v-model="formSurgeryId"
                            placeholder="Sub-unit"
                            solo
                            dense
                            lighten-1
                            class="mb-3"
                        ></v-autocomplete>
                    </v-card>
                    <v-radio label="Make SPARE" class="" value="Spare"></v-radio>
                </v-radio-group>
                <v-btn @click="itemMove">
                    Move
                </v-btn>
                <v-btn class="ml-4" color="error" @click="itemDelete">
                    Delete
                </v-btn>
            </v-form>
        </v-card>
    </v-menu>
</template>
<script>
    import SelectedItemsInfo from '../components/SelectedItemsInfo'
    import { STATUSES_HOLIDAY, TYPES_HOLIDAY } from '@/constatns/typesOfHolidays'
    import { ROTA_STATUSES } from '@/common/constants'
    import { mapActions, mapGetters } from 'vuex'
    export default {
        name: 'RotaTransferForm',
        props: ['selectedItems', 'unSelectItem', 'transferAction', 'clearSelectedList'],
        data: () => ({
            formPopup: false,
            formRoleId: null,
            formClinicId: null,
            formSurgeryId: null,
            errorMessage: '',
            status: ROTA_STATUSES.working,
            deleteMode: false,
            ROTA_STATUSES: ROTA_STATUSES,
            formData: null
        }),
        computed: {
            ...mapGetters(['getPersonalRota', 'getClinicSurgeries', 'getClinics']),
            clinicSurgeries () {
                return this.getClinicSurgeries(this.formClinicId)
            },
            clinicRules () {
                const rules = []
                if (!this.status && !this.formRoleId && !this.formClinicId) {
                    rules.push(val => !!val || 'Clinic is required!')
                }
                return rules
            }
        },
        methods: {
            ...mapActions(['reassignPersonalRota', 'fetchCheckDate', 'showAlert']),
            clinicChangeHandler () {
                this.formSurgeryId = null
            },
            async formSubmit () {
                this.errorMessage = ''
                if (!this.status && !this.formRoleId && !this.formClinicId && !this.deleteMode && this.status === 'clinic') {
                    this.errorMessage = 'Clinic, role or status is required!'
                    return
                }
                this.formData = this.createFormData(this.selectedItems)
                const responseCheckDate = await this.fetchCheckDate({
                    data: {
                        date: this.formData[0].date,
                        employeeIds: [this.formData[0].employeeId]
                    }
                })
                const responseHoliday = responseCheckDate.data.holidays
                const isExistApproveLevel1 = responseHoliday.some((item) => item.status === STATUSES_HOLIDAY.APPROVED_LEVEL_1_NAME)
                const isExistApproveLevel2 = responseHoliday.some((item) => item.status === STATUSES_HOLIDAY.APPROVED_LEVEL_2_NAME)

                const defaultOptions = {
                    type: this.deleteMode ? 'warning' : 'info',
                    action: this.deleteMode ? 'delete' : 'save',
                    agreeBtnText: this.deleteMode ? 'Remove' : 'Move',
                    text: this.deleteMode ? 'Do you really want to remove ?' : 'Do you really want to move ?'
                }

                let description = null

                if (responseHoliday.length === 0) {
                    this.saveData(this.formData)
                    return
                }

                if (responseHoliday[0].status === STATUSES_HOLIDAY.REQUEST) {
                    description = "A holiday request overlapping date(s) exists. Changing the Rota might affect employee's expectations."
                }

                if (this.deleteMode === false) {
                    if (responseHoliday[0].type === TYPES_HOLIDAY.SICK_LEAVE_NAME && responseHoliday[0].isLocked === false) {
                        description = "The record will be virtually placed to the destination, but you won't be able to see this until ongoing sickness is locked. Until then all records will be displayed in OFF"
                        if (await this.$root.$confirmDialog.open(null, defaultOptions, description)) {
                            this.saveData(this.formData)
                        }
                        return
                    }

                    if (
                        (responseHoliday[0].type === TYPES_HOLIDAY.SICK_LEAVE_NAME && responseHoliday[0].isLocked === true) ||
                        (responseHoliday[0].type === TYPES_HOLIDAY.MATERNITY_LEAVE_NAME) ||
                        (responseHoliday[0].type === TYPES_HOLIDAY.DEPENDENT_ABSENCE_NAME) ||
                        (responseHoliday[0].type === TYPES_HOLIDAY.UNAUTHORIZED_ABSENCE_NAME)
                    ) {
                        description = 'Employee has an overlapping leave or absence'
                        this.showAlert({
                            text: description,
                            type: 'error'
                        })
                        return
                    }
                }

                const checkIfConverted = this.selectedItems.findIndex(selectedItem => selectedItem.holiday && selectedItem.holiday.convertedToHoliday)
                if (checkIfConverted >= 0) {
                    description = 'Employee has an overlapping leave or absence'
                    this.showAlert({
                        text: description,
                        type: 'error'
                    })
                    return
                }

                if (
                    (isExistApproveLevel1 || isExistApproveLevel2) &&
                    responseHoliday[0].type !== TYPES_HOLIDAY.SICK_LEAVE_NAME &&
                    responseHoliday[0].type !== TYPES_HOLIDAY.MATERNITY_LEAVE_NAME &&
                    responseHoliday[0].type !== TYPES_HOLIDAY.DEPENDENT_ABSENCE_NAME &&
                    responseHoliday[0].type !== TYPES_HOLIDAY.UNAUTHORIZED_ABSENCE_NAME
                ) {
                    if (this.selectedItems[0].designator === responseHoliday[0].designator) {
                        description = 'Existing holiday or absence overlaps an approved holiday. No Rota actions allowed while holiday is approved in order to prevent a possible confusion'
                        this.showAlert({
                            text: description,
                            type: 'error'
                        })
                        return
                    }
                }

                if (await this.$root.$confirmDialog.open(null, defaultOptions, description)) {
                    this.saveData(this.formData)
                }
            },
            async saveData (formData) {
                try {
                    await this.transferAction({
                        records: formData
                    })
                    this.formPopup = false
                    this.$refs.moveForm.reset()
                    const infoText = this.deleteMode ? 'Successfully deleted!' : 'Successfully moved!'
                    this.$emit('successSubmit', infoText)
                } catch (e) {}
            },
            createFormData (data) {
                const status = this.status ? this.status : ROTA_STATUSES.working
                return data.map(item => {
                    if (this.deleteMode) {
                        return {
                            employeeDefaultRotaDayId: item.employeeDefaultRotaDayId,
                            id: item.id,
                            employeeId: item.employeeId,
                            designator: item.designator,
                            date: new Date(item.date).toISOString(),
                            roleId: this.formRoleId ? this.formRoleId : item.roleId,
                            clinicId: null,
                            surgeryId: null,
                            status: null
                        }
                    } else {
                        return {
                            date: new Date(item.date).toISOString(),
                            employeeDefaultRotaDayId: item.employeeDefaultRotaDayId,
                            id: item.id,
                            designator: item.designator,
                            employeeId: item.employeeId,
                            isExtra: item.isExtra,
                            note: item.note,
                            status,
                            roleId: this.formRoleId ? this.formRoleId : item.roleId,
                            clinicId: this.formClinicId ? this.formClinicId : item.clinicId,
                            surgeryId: this.formSurgeryId ? this.formSurgeryId : this.surgeryId
                        }
                    }
                })
            },
            itemDelete () {
                this.deleteMode = true
                this.formSubmit()
            },
            itemMove () {
                this.deleteMode = false
                this.formSubmit()
            }
        },
        components: {
            SelectedItemsInfo
        }
    }
</script>
